<div class="section_7">
  <div class="section_7-cards">
    <div class="section_7-card" style="background: #C173FF;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/star_2.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary">
        <ng-container i18n>Leave reviews with badges</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>Our badge system saves you time and provides us with valuable insights on what matters most to travelers when choosing hostels.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_0.webp" alt="">
      </div>
    </div>

    <div class="section_7-card" style="background: #3BB0F2;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/thumb_2.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary">
        <ng-container i18n>Recommend hostels to other travelers</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>Your insights help fellow explorers make better choices, creating a community of travel enthusiasts who look out for one another.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_1.webp" alt="">
      </div>
    </div>

    <div class="section_7-card" style="background: #00C5AD;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/backback.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary card-header font-secondary-3">
        <ng-container i18n>Book hostels for less</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>Every stay on hostel hop is 1% off. Earn 1% back on every booking in hopping credits to use toward your future travel experiences.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_2.webp" alt="">
      </div>
    </div>

    <div class="section_7-card" style="background: #FFC700;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/camera.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary">
        <ng-container i18n>Redeem credits for cash</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>When other travelers take your recommendations you can earn credits redeemable for cash, so you can sustain your hostel hopping journey.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_3.webp" alt="">
      </div>
    </div>

    <div class="section_7-card" style="background: #FF417A;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/map.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary">
        <ng-container i18n>Build maps to share with friends</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>Build maps with your favorite hostels like playlists, and share them on social media. Earn hopping credits anytime someone books with your map.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_4.webp" alt="">
      </div>
    </div>

    <div class="section_7-card" style="background: #C173FF;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/bell.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary">
        <ng-container i18n>Receptionists can earn more</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>Are you working at a hostel to extend your travels? Join our receptionist program to earn cash for spreading the word about hostel hop.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_5.webp" alt="">
      </div>
    </div>

    <div class="section_7-card" style="background: #3BB0F2;">
      <div class="card-icon">
        <svg-icon style="height: 26px" [svgStyle]="{'width.px': 26, 'height.px': 26}" src="/assets/icons/phone.svg"></svg-icon>
      </div>
      <div class="card-header font-secondary">
        <ng-container i18n>Contact your hostel directly</ng-container>
      </div>
      <div class="card-content">
        <ng-container i18n>We don't gate keep contact information. Feel free to reach out to your hostel directly to learn more about your stay.</ng-container>
      </div>
      <div class="card-img">
        <img src="/assets/images/image 4_6.webp" alt="">
      </div>
    </div>
  </div>
  <div class="scroller">
    <div class="scroller-bg">
    </div>
  </div>
</div>
